import React, { Component } from "react";
import UserTask from "./UserTask";
import AddUser from "./AddUser";
import { Link, Route } from "react-router-dom";
import Single from "./Single";
import AddTask from "./AddTask";
import SignInForm from "./SignInForm";
import Title from "./Title";

class Main extends Component {
  state = {
    loading: true,
  };

  componentDidMount() {
    this.props.startLoadingUser().then(() => {
      this.setState({ loading: false });
    });
    this.props.startLoadingTasks();
  }

  render() {
    return (
      <div className="container">
        <Title {...this.props} />
        <Route
          exact
          path="/"
          render={() => {
            if (this.props.auth.authenticated === false) {
              return <SignInForm {...this.props} />;
            }

            return (
              <div>
                <UserTask {...this.props} />
              </div>
            );
          }}
        />

        <Route
          exact
          path="/SignInForm"
          render={({ history }) => (
            <div>
              <SignInForm {...this.props} />
            </div>
          )}
        />

        <Route
          path="/AddUser"
          render={({ history }) => <AddUser {...this.props} />}
        />

        <Route
          path="/single/:id"
          render={(params) => (
            <Single
              {...this.props}
              {...params}
              loading={this.state.loading}
              startLoadingTasks={this.props.startLoadingTasks}
            />
          )}
        />

        <Route
          path="/AddTask/:id"
          render={(params) => (
            <AddTask {...this.props} {...params} loading={this.state.loading} />
          )}
        />
      </div>
    );
  }
}

export default Main;
